<template>
  <div style="width: 1200px; margin: 0 auto">
    <div style="z-index: -1;">
      <!--head-->
      <div class="selectedTitle">
        <span>
           {{$t('mall_home.jewellery_box')}}<!-- 搜飾盒 -->
        </span>
        <img :src="require('@/assets/homeImg/ssjg_mbx_jt@2x.png')" alt="">
        <span>
          {{$t('mall_home.gia')}}<!-- 鑽石定制 -->
        </span>
        <img :src="require('@/assets/homeImg/ssjg_mbx_jt@2x.png')" alt="">
        <!--        <span>戒指</span>-->
        <!--        <img :src="require('@/assets/homeImg/ssjg_mbx_jt@2x.png')" alt="">-->
        <span class="selectItem">
          {{$t('mall_gia_detail.diamond')}}
<!--          {{productGIA.name}}-->
        </span>
      </div>
      <div class="divider"></div>
      <div class="productBox clearFix">
        <div v-if="this.productGIA.video_link===''" class="leftBox" @mouseenter="showBig">
          <vue-magnify
            @move="handleMove"
            :previewImg="modelPath.min"
            :zoomImg="modelPath.max">
          </vue-magnify>
          <div class="productImgShow" style="overflow:hidden;">
            <div v-for="(item,index) in modelPathList"
                 :key="index"
                 @mouseenter="changeImage(index)" class="smallImg"
                 ref="smallImg"
                 @click="smallImgChoose(index)">
              <img :src="item.min" alt="">
            </div>
          </div>
        </div>
        <div v-else class="leftBox">
          <el-main v-show="iframeLoading" v-loading="iframeLoading" style="width: 430px; height: 530px; position: absolute"></el-main>
        </div>
        <div class="rightBox" :style="{width:boxW}">
          <div>
            <div class="header displayR">
              <span style="max-width: 300px; overflow: hidden;font-size: 24px">{{productGIA.name}}</span>
              <!--              <img :src="require('@/assets/homeImg/spxq_icon_bq@2x.png')" alt="">-->
              <!--<img class="collectionIcon" :src="require('@/assets/homeImg/spxq_icon_aixin@2x.png')" alt="">-->
            </div>
            <div class="rightPrice">
              <span style="font-size:22px;color: #B5B5B5">
                {{$t('mall_gia_search.price')}}<!-- 價格 -->
              </span>
              <span style="font-size:16px;color:#FF726C;">
                {{productGIA.currency_symbol}}
              </span>
              <span style="width:68px;height:40px;font-size:28px;font-weight:500;color:#FF726C;">
                {{productGIA.amount|PriceFormat}}
              </span>
            </div>
            <div class="line"></div>
            <div style="padding: 1px 15px 20px 15px;background-color: #FCFBF9;margin-top: 15px;">
              <div>
                <div class="parameter">
                 {{$t('mall_gia_detail.params')}} <!-- 鑽石參數 -->
                </div>
                <div style="position: relative; overflow: hidden;margin: 25px 0">
                  <div v-for="(item,index) in productGIA.params" :key="index">
                    <div style="width: 110px;float: left;margin-top: 5px">
                      <span>{{item.key}}: </span>
                      <span>{{item.value}}</span>
                    </div>
                    <!--                    <span class="parameterName">{{item.key}}</span>-->
                    <!--                    <span>{{item.value}}</span>-->
                  </div>
                </div>
                <div class="line"></div>
                <div class="parameter">
                  {{$t('mall_gia_detail.gia_cer')}}<!-- Gia證書 -->
                </div>
                <div style="margin-top: 23px">
                  <span style="width:107px;height:22px;font-size:16px;font-weight:400;color:#979694;">
                    {{$t('mall_gia_search.certificate_num')}} ：<!-- 證書編號 -->
                  </span>
                  <span style="width:92px;height:22px;font-size:16px;font-weight:400;color:#50504F;">
                    {{productGIA.cert_no}}
                  </span>
                </div>
                <div class="btns displayR">
                  <div class="shopNow" @click="showFBDialogs()">
                    {{$t('mall_gia_detail.contact_us')}}<!-- 在線咨詢 -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="textTitle">
      {{$t('mall_gia_detail.gia_cer')}} <!-- GIA證書 -->
    </div>
    <div class="line"></div>
    <img style="width: 100%;margin-top:40px" :src="productGIA.certificate_link" alt="">
    <div class="textTitle">
     {{$t('mall_gia_detail.custom_process')}} <!-- 定制流程 -->
    </div>
    <div class="line"></div>
    <img v-if="this.$i18n.locale==='en'" style="width: 100%;margin-top:40px " src="https://ssh-prod-public.oss-cn-shenzhen.aliyuncs.com/mall/diamond_customization_en.png" alt="">
    <img v-else style="width: 100%;margin-top:40px " src="https://ssh-prod-public.oss-cn-shenzhen.aliyuncs.com/mall/diamond_customization.png" alt="">
    <div style="margin-bottom: 60px"></div>
  </div>
</template>

<script>
  import Vue from 'vue'
  import PriceFormat from '@/assets/js/PriceFormat';
  import baseUrl from '@/api/baseUrl.js'
  import vueMagnify from 'vue-magnify';
  import { Loading } from 'element-ui';

  Vue.use(vueMagnify);
  let speed = 5;
  export default {
    name: "Product",
    components: {},
    data() {
      return {
        iframeLoading: null,
        options: {
          target: '#iframe',
          fullscreen: false
        },
        imgUrl: baseUrl.imgUrl,
        paddingNum: '',
        mr: '',
        itemW: 0,
        boxW: 0,
        num: 1,
        cartNum: 1,
        color_id: 0,
        value: '',
        isShow: false,
        choose: false,
        index: 0,
        flag: false,
        offset: 0,
        timer: null,
        curr: 0,
        playStatus: '',
        muteStatus: '',
        isMute: true,
        isPlay: false,
        area: 440300,
        hotTop: 0,
        modelPath: {
          min: '',
          max: '',
        },
        modelPathList: [],
        drawer: false,
        direction: 'rtl',
        dialogVisible: false,
        goods: [],
        show: true,
        productGIA: {
          name: '',
          stock_id: '',
          params: [
            {
              key: '',
              value: ''
            }
          ],
          image_link: '',
          video_link: '',
          currency_symbol: '',
          amount: '',
          cert_no: '',
          certificate_link: '',
          certificate_image_text: [],
          contact_us: ''
        },
        orderData: [
          {
            product_model_id: '',
            product_color_id: '',
            product_size: '',
          }
        ],
        Totals: 0,
      }
    },
    filters: {
      PriceFormat(val) {
        return PriceFormat(val);
      }
    },
    methods: {
      showFBDialogs() {
        console.log("showDialog")
        FB.CustomerChat.showDialog();
      },
      showBig() {

      },
      handleMove() {

      },
      handleClose(done) {
        done();
      },
      handleAddCart(value) {
        console.log(value);
      },
      //放大鏡
      changeImage: function (index) {
        this.modelPath = this.modelPathList[index];
      },
      //選擇尺寸
      chooseSize(value) {
      },
      //購買數量選擇
      handleChange(value) {
      },
      chooseMt(color_id, index) {
        this.orderData[0].product_color_id = color_id;
        let that = this;
        let mater = document.getElementsByClassName('material');

        that.$refs.arrow.forEach((item, indexItem) => {
          if (index === indexItem) {
            that.choose = true;
            mater[indexItem].className = ' material active';
          } else {
            that.choose = false;
            mater[indexItem].className = ' material';
          }
        });
        this.$refs.arrow.forEach((item, indexItem) => {
          if (index === indexItem) {
            item.style.display = 'block';

          } else {
            item.style.display = 'none';
          }
        })
      },
      smallImgChoose(index) {
        let that = this;
        this.$refs.smallImg.forEach((item, indexItem) => {
          if (index === indexItem) {
            that.choose = true;
          } else {
            that.choose = false;
          }
        });
      },
      //獲取gia數據
      getGIADetail(id) {
        this.$axios.get('api/app_v1/gia/detail/' + id, {}).then(res => {
          this.productGIA = res.data.data;
          console.log('獲取gia數據')
          this.modelPathList.push({
            min: this.productGIA.image_link + '?x-oss-process=image/resize,m_fill,h_430,w_430',
            max: this.productGIA.image_link + '',
          });
          this.modelPath = this.modelPathList[0];
          console.log("getGIADetail:modelPathList  ", this.modelPathList);
          // this.color_id = this.productGIA.color_photo[0].product_color_id;
          this.changeImage(0);
          if (this.productGIA.video_link) {
            this.iframeLoad();
          }
        });
      },
      iframeLoad() {
        this.iframeLoading = true;
        let iframeBox = document.querySelector('.leftBox');
        let iframe = document.createElement("iframe");
        iframe.src = this.productGIA.video_link;
        iframe.width = '430px';
        iframe.height = '530px';
        iframe.setAttribute('frameborder', '0', 0);
        let that = this;
        if (iframe.attachEvent){
          iframe.attachEvent("onload", function(){
            that.iframeLoading = false;
          });
        } else {
          iframe.onload = function(){
            that.iframeLoading = false;
            console.log('加载失败')
          };
        }
        iframeBox.appendChild(iframe);
      }
    },
    mounted() {

    },
    created() {
      this.getGIADetail(this.$route.query.id);
      document.body.scrollTop = document.documentElement.scrollTop = 0;
      let aa = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
      if (aa >= 1900) {
        this.paddingNum = '0 210px';
        this.mr = '210px';
        this.itemW = (aa - 210) / 4 - 10 * 2;
        this.boxW = '480px';
      } else {
        this.paddingNum = '0 100px';
        this.mr = '100px';
        this.itemW = (aa - 100) / 4 - 10 * 2
        this.boxW = '480px';
      }
      // this.iframeLoading = Loading.service(this.options);
    },

  }
</script>

<style lang="less" scoped>
  .divider {
    width: 100%;
    height: 1px;
    background-color: #ddd;
  }

  .productBox {
    width: 90%;
    margin: 30px auto;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }

  .leftBox {
    padding: 0 40px;
    width: 430px;
    float: left;
    /*margin-right: 30px;*/
    /*border: 1px solid #ddd;*/
    position: relative;
  }

  .bigBox > img {
    width: 200%;
    height: 200%;
  }

  .productImg .magnifier-box > img {
    /*width: 60%;*/
  }

  .smallImg {
    width: 60px;
    height: 60px;
    border: 1px solid #ddd;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    float: left;
    margin-right: 10px;
  }

  .smallImg:hover {
    -webkit-box-shadow: 0px 0px 5px 1px rgba(30, 19, 3, 0.13);
    -moz-box-shadow: 0px 0px 5px 1px rgba(30, 19, 3, 0.13);
    box-shadow: 0px 0px 5px 1px rgba(30, 19, 3, 0.13);
  }

  /*.smallImgActive {*/
  /**/
  /*}*/
  .smallImg > img {
    width: 80%;
  }

  .rightBox {
    color: #7A7977;
    font-size: 14px;
    margin-left: 30px;
    height: 550px;
    /*float: left;*/
    /*border: 1px solid #ddd;*/
  }

  .header {
    font-size: 22px;
    color: #353433;
    margin-top: 20px;
    align-items: center;
    position: relative;
    align-items: center;
  }

  .collectionIcon {
    width: 18px !important;
    height: 15px !important;
    position: absolute;
    right: 10px;
  }

  .rightHead > span {
    color: #353433;
    font-size: 22px;
    margin-right: 10px;
  }

  .header > img {
    width: 57px;
    height: 24px;
    margin-left: 10px;
  }

  .rightPrice {
    color: #1E1303;
    font-size: 28px;
    padding-top: 10px;
  }

  .material {
    overflow: hidden;
    width: 63px;
    height: 63px;
    border: 1px solid #ddd;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    float: left;
    margin-right: 10px;
    position: relative;
  }

  .material > img {
    /*width: 80%;*/
  }

  .arrow {
    position: absolute;
    bottom: -1px;
    right: 0;
    width: 22px !important;
    height: 23px;
    display: none;
  }

  .active {
    border: 1px solid #D7B189 !important;
  }

  .sizeBox {
    align-items: center;
    height: 34px;
    margin-top: 30px;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;

  }

  .line {
    width: 100%;
    height: 1px;
    margin: 10px 0 10px 0;
    background-color: #ddd;
  }

  .chooesSize {
    /*width: 134px;*/
    /*height: 34px;*/
  }

  .parameter {
    margin-top: 20px;
    color: #50504F;
    font-size: 15px;
  }

  .parameterItem {
    padding: 5px 0 5px 0;
    width: 100%;
    display: flex;
  }

  .parameterItem span {
    display: inline-block;
    flex: 1;
  }

  .parameterName {

  }

  .btns {
    margin-top: 30px;
    width: 100%;
    text-align: center;
    justify-content: center;
    align-items: center;
  }

  .shopNow {
    padding: 8px 0;
    color: #fff;
    cursor: pointer;
    flex: 1;
    font-size: 18px;
    background-color: #C0A876;
    -webkit-border-radius: 2px;
    -moz-border-radius: 2px;
    border-radius: 2px;
  }


  /*產品*/
  .product_box {
    background-color: #fff;
    /*padding: 100px;*/
    position: relative;
  }

  .product-list {
    position: relative;
    width: 100%;
    height: 380px;
    /*margin-top: 30px;*/
    overflow: hidden;
    /*padding: 47px 0;*/
    box-sizing: border-box;
    background-color: #F5F1ED;
    padding: 30px;

  }

  .show-list {
    position: absolute;
    top: 0;
    left: 0;
    /*overflow: hidden;*/
    width: 1000%;
    height: 100%;
    margin-bottom: 0;
    /*background-color: #f00;*/
    /*padding: 0 30px;*/
    /*overflow: hidden;*/

  }

  .item {
    width: 3.33%;
    height: 100%;
    float: left;
    list-style: none;
    /*padding: 40px;*/
    display: flex;
    flex-direction: row;
    justify-content: center;

    /*background-color: #fff;*/

  }

  .li_box {
    font-size: 18px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-width: 192px;
    min-height: 192px;
    background-color: #F5F1ED;
    border: 1px solid #ddd;

    /*margin-right: 10px;*/

  }

  .li_box p {
    overflow: hidden; /*超出部分隱藏*/
    white-space: nowrap; /*不換行*/
    text-overflow: ellipsis; /*超出部分省略號顯示*/
  }

  .li_box a {
    border: none !important;
    text-align: center;
    width: 80%;
  }

  .li_box img {
    width: 100%;
  }


  .collocation {
    margin-top: 100px;
  }

  .align-items-center {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .collocationHead {
    text-align: center;
    width: 80%;
    padding: 20px 0;
    color: #1E1303;
    font-size: 22px;

  }

  .mask {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 99;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.2);
  }

  .allBox {
    margin: 20px;
  }

  .cartItems {
    width: 100%;
    background-color: #fff;
    color: #1E1303;
    overflow-y: hidden;
    z-index: 999;
    margin-bottom: 100px;
  }

  .maskLeft {
    flex: 2;
  }

  .close {
    width: 20px;
    position: absolute;
    right: 50px;
  }

  .close:hover {
    opacity: 0.6;
  }

  .close > img {
    width: 100%;
  }

  .shopBag {
    font-size: 22px;
    border-bottom: 1px solid #ddd;
    padding-bottom: 10px;
  }

  .sum {
    color: #7A7977;
    font-size: 14px;
  }

  .imgBox {
    width: 150px;
    height: 150px;
    background-color: #fff;
    border: 1px solid #ddd;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }

  .imgBox > img {
    width: 127px;
    /*height: 56px;*/
  }

  .remove {
    color: #979694;
  }

  .remove > img {
    width: 12px;
    height: 12px;

  }

  .maskBox {
    height: 172px;
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 20px;
  }

  .maskRight {
    height: 100%;
    flex: 3;
    box-sizing: border-box;
    border-bottom: 1px solid #ddd;
    padding-bottom: 30px;
  }

  .maskRightHead {
    font-size: 18px;

  }

  .maskAmount {
    font-size: 14px;
    color: #979694;
  }

  .chooseDetail {
    color: #979694;
    font-size: 14px;
    display: flex;
    flex-direction: row;
    /*justify-content: space-between;*/
    align-items: center;
    padding: 10px 0;

  }

  .chooseDetail div {
    flex: 1;
  }

  .countInp {
    flex: 1;
  }

  .unitPrice {
    margin-top: 20px;
  }

  .shopBag {
    margin-bottom: 30px;
  }


  /**動畫初始和結束的時候*/
  /*position: absolute;*/
  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s
  }

  .fade-enter, .fade-leave-active {
    opacity: 0
  }

  .list-enter-active, .list-leave-active {
    transition: all 1s;
  }

  .list-enter, .list-leave-to
    /* .list-leave-active for below version 2.1.8 */ {
    opacity: 0;
    transform: translateY(30px);
  }

  /deep/ .leftBox .vue-magnify {

  }

  /deep/ .leftBox .vue-magnify .preview-box {
    display: flex;
    align-items: center;
    border: none !important;
  }

  /deep/ .leftBox .vue-magnify .preview-box > img {
  }

  /deep/ .el-select-dropdown__item {
    text-align: center;
  }

  /deep/ .vue-magnify .zoom-box {
    left: 490px;
    /*height: 450px;*/
    background-color: #fff;
    z-index: 999;
    border-color: #DDD !important;
  }

  /deep/ .vue-magnify .zoom-box > img {
    left: 450px;
    /*height: 450px;*/
    background-color: #fff;
    z-index: 99;
    border-color: #DDD !important;
  }

  .textTitle {
    font-size: 14px;
    font-weight: 400;
    color: rgba(30, 19, 3, 1);
    margin-top: 20px;
  }

  /deep/ .el-select-dropdown__item {
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/views/viewHK/GIADetail.vue